import { render, staticRenderFns } from "./SubirArchivo.vue?vue&type=template&id=60912396&"
import script from "./SubirArchivo.vue?vue&type=script&lang=js&"
export * from "./SubirArchivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports